{
    "customer_detail__no_tasks": "Aucune tâche pour l'instant",
    "customer_detail__no_tasks_description": "Utilisez les tâches pour déléguer ou pour vous fixer un rappel",
    "customer_detail__add_task": "Créer une tâche",
    "customer_detail__no_open_tasks": "Aucune tâche pour l'instant",
    "customer_detail__no_open_tasks_description": "Utilisez les tâches pour déléguer ou pour vous fixer un rappel",
    "customer_detail__no_completed_tasks": "Aucune tâche pour l'instant",
    "customer_detail__no_completed_tasks_description": "Il n'y a actuellement aucune tâche terminée pour ce client",
    "customer_detail__no_notes": "Aucune interaction",
    "customer_detail__no_notes_description": "Utilisez les interactions pour enregistrer des informations sur ce client et les rendre accessibles à toute l'équipe",
    "customer_detail__add_note": "Enregistrer une interaction",
    "status_change__status_active": "Actif",
    "status_change__status_inactive": "Inactif",
    "status_change__marked_inactive": "<strong>Marqué comme définitivement inactif</strong> par {{user}}",
    "status_change__reactivated": "<strong>Marqué comme actif</strong> par {{user}}",
    "log__status_inactive": "Marqué comme définitivement inactif",
    "log__status_active": "Marqué comme actif",
    "log__insight_interested": "{{insightType}} « {{entity}} » marqué comme pertinent",
    "log__insight_no_need": "{{insightType}} « {{entity}} » marqué comme pas de besoin",
    "log__insight_buys_elsewhere": "{{insightType}} « {{entity}} » marqué comme achète ailleurs",
    "log__insight_not_relevant": "{{insightType}} « {{entity}} » marqué comme non pertinent",
    "log__insight_value": "Potentiel de chiffre d'affaires : {{value}}",
    "search_placeholder__customer": "Rechercher article, commande, devis …",
    "search_placeholder__global": "Rechercher client, note, tâche",
    "filter__title": "Filtre",
    "filter__add": "Filtre",
    "filter__apply": "Appliquer",
    "filter__clear_all": "Tout effacer",
    "filter__close": "Fermer",
    "filter__back": "Retour",
    "filter__remove": "Supprimer le filtre {{filter}}",
    "filter__category_type": "Type",
    "search__clear": "Effacer la recherche",
    "presets__label": "Filtres rapides",
    "day__no_due_date": "Sans échéance",
    "feed__empty": "Aucune activité",
    "feed__pinned": "Épinglées",
    "card__positions_load_error": "Impossible de charger les postes",
    "card__open": "Ouvrir {{name}}",
    "card__attachments_one": "{{count}} pièce jointe",
    "card__attachments_many": "{{count}} pièces jointes",
    "card__attachments_other": "{{count}} pièces jointes",
    "card__quote_title": "Devis : #{{id}}",
    "card__order_title": "Commande : #{{id}}"
}
